import { collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore";
import {
  ADMIN_CONTENT_DOC_ID,
  contentFieldsOnly,
  looksLikeContentDoc,
} from "../constants/adminContent";

/**
 * Load stable `admin/app_content`. If missing, copy once from a legacy
 * `admin/{uid}` content doc so changing admin accounts never loses site data.
 */
export async function loadOrMigrateAdminContent(db) {
  const contentRef = doc(db, "admin", ADMIN_CONTENT_DOC_ID);
  const contentSnap = await getDoc(contentRef);

  if (contentSnap.exists()) {
    return { id: contentSnap.id, ...contentSnap.data() };
  }

  const querySnapshot = await getDocs(collection(db, "admin"));
  const legacy = querySnapshot.docs.find(
    (d) => d.id !== ADMIN_CONTENT_DOC_ID && looksLikeContentDoc(d.data())
  );

  if (!legacy) {
    return null;
  }

  const migrated = contentFieldsOnly(legacy.data());
  await setDoc(contentRef, migrated);
  return { id: ADMIN_CONTENT_DOC_ID, ...migrated };
}
